<div class="d-lg-none d-block">
  <fgb-page-header [pageTitle]="'games.page.polls.title'" [backButtonLink]="'/games'" [showFooter]="false"> </fgb-page-header>
</div>
<div class="bg-primary pb-4 py-lg-0 pt-3" role="banner" [ngClass]="{ 'kid-bg': isKid }">
  <div class="container">
    <div class="d-none d-lg-flex text-white page-back-button-section" [routerLink]="['/games']">
      <span class="material-icons me-2">navigate_before</span>{{ 'games.back.button.text' | translate }}
    </div>
    <img class="polls-banner" [src]="'banner-images/polls-banner.png' | contentAssetImage" alt="polls-banner" />
  </div>
</div>
<div class="bg-muted mobile-content-wrapper pt-2 pt-lg-0">
  <div class="container">
    <ng-container *ngIf="pollsQuestion$ | async as pollsQuestions; else shimmerEffect">
      <ng-container *ngIf="pollsQuestions.length > 0">
        <fgbcl-game-polls-question-list [pollsQuestions]="pollsQuestions" (answerSelected)="onAnswerSelected($event)">
        </fgbcl-game-polls-question-list>
      </ng-container>
    </ng-container>

    <!-- Shimmer Effect -->
    <ng-template #shimmerEffect>
      <div class="card" aria-hidden="true" *ngFor="let i of [1, 2, 3]">
        <h6 class="card-title placeholder-glow text-center">
          <span class="question-shimmer-effect placeholder col-6"></span>
        </h6>
        <div class="answer-shimmer-effect-section">
          <p class="card-text placeholder-glow w-100 mb-0 text-center">
            <span class="answer-shimmer-effect placeholder col-12"></span>
          </p>
          <p class="card-text placeholder-glow w-100 mb-0 text-center">
            <span class="answer-shimmer-effect placeholder col-12"></span>
          </p>
        </div>
        <div class="answer-shimmer-effect-section mt-3">
          <p class="card-text placeholder-glow w-100 mb-0 text-center">
            <span class="answer-shimmer-effect placeholder col-12"></span>
          </p>
          <p class="card-text placeholder-glow w-100 mb-0 text-center">
            <span class="answer-shimmer-effect placeholder col-12"></span>
          </p>
        </div>
        <div class="d-flex align-items-center justify-content-center">
          <p class="card-text placeholder-glow w-40 text-center">
            <span class="presentby-shimmer-effect placeholder col-7"></span>
          </p>
        </div>
      </div>
    </ng-template>
  </div>
</div>
